// Exposures
// TODO - Documentar
import { useEffect, useState } from 'react'
import * as con from "../../GlobalConstants"

// Style
import "../ComponentsGlobalStyle.css"
import { TransactionTable } from '../transactionTable/TransactionTable'
import TransactionTableVisualizer from './TransactionTableVisualizer'
import { SpotCoveragesHook, useTransactionAnnotations, useTransactionFilters } from '../hooks/TransactionsHooks'
import { RefModelParameterHook } from '../hooks/ModelParameterHooks'
import { allSpotCoverageColumns, selectedSpotCoverageColumns } from '../../utils/transactionFunctions'
import { useDispatch } from "react-redux"
import { addTransaction, deleteTransaction, updateTransaction } from "../../store/slices/transactionsSlice"


function TableCoveragesSpot() {

  
  // Transaction
  const trans = SpotCoveragesHook()  

  // Client Type
  const clientType = RefModelParameterHook(con.CLIENT_TYPE)

  const { searchFun } = useTransactionFilters()
  const dispatch = useDispatch()
  const getAnnotations = useTransactionAnnotations(con.COVERAGES_SPOT)

  // Columns
  const [columns, setColumns] = useState(() => selectedSpotCoverageColumns.map(col =>  allSpotCoverageColumns[col[con.ID]]))

  useEffect(() => {
    
    let colsTemp = selectedSpotCoverageColumns.map(col =>  allSpotCoverageColumns[col[con.ID]])

    let openDate = colsTemp.find((col) => col[con.ID] === con.OPENING_DATE) 
    openDate[con.NAME] = `Fecha ${clientType === con.IMPORTER ? "Compra" : "Monetización"}`

    let rate = colsTemp.find((col) => col[con.ID] === con.RATE) 
    rate[con.NAME] = `Tasa ${clientType === con.IMPORTER ? "Compra" : "Monetización"}`

    setColumns(colsTemp)

  }, [clientType])
  
 
  return (
        <TransactionTableVisualizer transactionType={con.COVERAGES_SPOT}>           
                    <TransactionTable transactionType={con.COVERAGES_SPOT}
                            columnArray={columns} 
                            dataDictionary={trans} 
                            setRow={(id, vals) =>
                              dispatch(updateTransaction({
                                transactionType: con.COVERAGES_SPOT,
                                id,
                                values: vals
                              }))
                            }
                            addRow={(vals) =>
                              dispatch(addTransaction({
                                transactionType: con.COVERAGES_SPOT,
                                values: vals
                              }))
                            }
                            deleteRow={(id) =>
                              dispatch(deleteTransaction({
                                transactionType: con.COVERAGES_SPOT,
                                id
                              }))
                            }
                            getAnnotations={getAnnotations}
                            searchFunction={searchFun}/>
        </TransactionTableVisualizer>        
  )
}

export default TableCoveragesSpot